import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

import Checkout from "../components/Checkout";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Header from "../components/Header";
import {
  applyThemeVarsToElement,
  clearThemeVarsFromElement,
  getEventThemeVars,
} from "../utility/colorUtils";

const EventTicketing = () => {
  const { eventId, participantId, paymentStatus } = useParams();
  const [event, setEvent] = useState();
  const [participant, setParticipant] = useState();
  const [style, setStyle] = useState({});

  const loadEvent = async () => {
    const eventRef = doc(db, "Events", eventId);
    let loadedEvent;

    await getDoc(eventRef)
      .then((snapshot) => {
        const data = {
          id: snapshot.id,
          ...snapshot.data(),
        };
        loadedEvent = data;
      })
      .catch((err) => {
        console.log("Fetch event failed: " + err);
      });

    setStyle(getEventThemeVars(loadedEvent));
    setEvent(loadedEvent);
  };

  const loadParticipant = async () => {
    const participantRef = doc(db, "Events", eventId, "Participants", participantId);
    let loadedParticipant;

    await getDoc(participantRef)
      .then((snapshot) => {
        const data = {
          id: snapshot.id,
          ...snapshot.data(),
        };
        loadedParticipant = data;
      })
      .catch((err) => {
        console.log("Fetch participant failed: " + err);
      });
    setParticipant(loadedParticipant);
  };

  useEffect(() => {
    if (eventId.length) {
      loadEvent();
      loadParticipant();
    }
  }, [eventId]);

  useEffect(() => {
    if (!event) return undefined;
    applyThemeVarsToElement(document.body, getEventThemeVars(event));
    return () => {
      clearThemeVarsFromElement(document.body);
    };
  }, [event]);

  return (
    <div
      className={`event-checkout ${event?.darkMode === false ? "light-mode" : ""}`}
      style={style}
    >
      <Header logoUrl={event?.logoUrl} />
      {event && <Banner event={event} hideTitleOverlay />}
      {event && <Checkout event={event} participant={participant} paymentStatus={paymentStatus} />}
      <Footer logoUrl={event?.logoUrl} isDarkMode={event?.darkMode === false ? "light-mode" : ""} />
    </div>
  );
};

export default EventTicketing;
